import ArrowLeft from './icons/icon--arrow-left';
import ArrowRight from './icons/icon--arrow-right';
import ArrowDown from './icons/icon--arrow-down';
import ChevronDown from './icons/icon--chevron-down';
import ChevronUp from './icons/icon--chevron-up';
import Close from './icons/icon--close';
import MenuClose from './icons/icon--menu-close';
import Download from './icons/icon--download';
import Facebook from './icons/icon--facebook';
import HamburgerMenu from './icons/icon--hamburger-menu';
import Instagram from './icons/icon--instagram';
import InstagramGradient from './icons/icon--instagram-gradient';
import Magnifier from './icons/icon--magnifier';
import NewTab from './icons/icon--new-tab';
import NewWindow from './icons/icon--new-window';
import OutlineSearch from './icons/icon--outline-search';
import Pause from './icons/icon--pause';
import Pinterest from './icons/icon--pinterest';
import Play from './icons/icon--play';
import Plus from './icons/icon--plus';
import Refine from './icons/icon--refine';
import Sorting from './icons/icon--sorting';
import Tiktok from './icons/icon--tiktok';
import Youtube from './icons/icon--youtube';
import Share from './icons/icon--share';
import ShareClose from './icons/icon--share-close';
import ChevronRight from './icons/icon--chevron-right';
import ChevronLeft from './icons/icon--chevron-left';
import Checkmark from './icons/icon--checkmark';
import ArrowDashRight from './icons/icon--arrow-dash-right';
import AlertNeutral from './icons/icon--alert-neutral';
import AlertPriority from './icons/icon--alert-priority';
import AccordionPlus from './icons/icon--accordion-plus';
import AccordionMinus from './icons/icon--accordion-minus';
import PrivacyChoices from './icons/icon--privacy-choices';
import Slash from './icons/icon--slash';
import KitchenTips from './icons/icon--kitchentips';
import Info from './icons/icon--info';
import Heart from './icons/icon--heart';
import HeartFilled from './icons/icon--heart-filled';
import Star from './icons/icon--star';
import Leading from './icons/icon--leading';
import CheckmarkCircled from './icons/icon--checkmark-circled';
import X from './icons/icon--x';
import LinkedIn from './icons/icon--linkedin';
import IconAccordionPlus from './icons/icon--accordion-plus';
import IconAccordionMinus from './icons/icon--accordion-minus';
import BulletCheckOutline from './icons/icon--bullet-check-outline';
import Minus from './icons/icon--minus';
import JumpTo from './icons/icon--jump-to';
import IconMail from './icons/icon-mail';
import Print from './icons/icon--print';
import Show from './icons/icon--show';
import Hide from './icons/icon--hide';
import IconGoogle from './icons/icon--google';
import IconToggleOffSwitch from './icons/icon-toggle-off-switch';
import IconToggleOnSwitch from './icons/icon-toggle-on-switch';
import IconLocationSelector from './icons/icon--location-selector';
import IconAccordionCross from './icons/icon--accordin--cross';
import Search from './icons/icon--search';
import Clear from './icons/icon--clear';
import IconCloseCircle from './icons/icon--close-circle';
import IconBulletCheckFill from './icons/icon--bullet-check-fill';
import IconCheck from './icons/icon--check';
import IconCloseSmall from './icons/icon--close-small';
import IconWriteReview from './icons/icon--write-review';
import IconCalendar from './icons/icon--calendar';
import IconShop from './icons/icon--shop';
import IconLogout from './icons/icon--logout';
import IconUserAccount from './icons/icon--user-account';
import IconCaretDown from './icons/icon--caret-down';
import IconHeartFavorites from './icons/icon--heart-favorites';
import IconAdChoices from './icons/icon--ad-choice';
import IconSettingDials from './icons/icon--setting-dials';
import IconManageFavorites from './icons/icon--manage-favorites';

export const IconMapping = {
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-down': ArrowDown,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  close: Close,
  'menu-close': MenuClose,
  download: Download,
  facebook: Facebook,
  'hamburger-menu': HamburgerMenu,
  instagram: Instagram,
  'instagram-gradient': InstagramGradient,
  magnifier: Magnifier,
  'new-tab': NewTab,
  'new-window': NewWindow,
  'outline-search': OutlineSearch,
  pause: Pause,
  pinterest: Pinterest,
  play: Play,
  plus: Plus,
  refine: Refine,
  sorting: Sorting,
  tiktok: Tiktok,
  youtube: Youtube,
  share: Share,
  'share-close': ShareClose,
  'chevron-right': ChevronRight,
  'chevron-left': ChevronLeft,
  checkmark: Checkmark,
  'arrow-dash-right': ArrowDashRight,
  'alert-neutral': AlertNeutral,
  'alert-priority': AlertPriority,
  'accordion-plus': AccordionPlus,
  'accordion-minus': AccordionMinus,
  'privacy-choices': PrivacyChoices,
  slash: Slash,
  kitchentips: KitchenTips,
  info: Info,
  heart: Heart,
  'heart-filled': HeartFilled,
  star: Star,
  leading: Leading,
  'checkmark-circled': CheckmarkCircled,
  x: X,
  linkedin: LinkedIn,
  iconAccordionPlus: IconAccordionPlus,
  iconAccordionMinus: IconAccordionMinus,
  'bullet-check-outline': BulletCheckOutline,
  minus: Minus,
  'jump-to': JumpTo,
  mail: IconMail,
  print: Print,
  show: Show,
  hide: Hide,
  google: IconGoogle,
  toggleOffSwitch: IconToggleOffSwitch,
  toggleOnSwitch: IconToggleOnSwitch,
  locationSelector: IconLocationSelector,
  accordionCross: IconAccordionCross,
  search: Search,
  clear: Clear,
  'close-circle': IconCloseCircle,
  check: IconCheck,
  'bullet-check-fill': IconBulletCheckFill,
  'close-small': IconCloseSmall,
  'write-review': IconWriteReview,
  calendar: IconCalendar,
  shop: IconShop,
  logout: IconLogout,
  'user-account': IconUserAccount,
  'caret-down': IconCaretDown,
  'heart-favorites': IconHeartFavorites,
  'ad-choices': IconAdChoices,
  'setting-dials': IconSettingDials,
  'manage-favorites': IconManageFavorites,
} as const;
